import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { HTTP } from "../../api/resources";
import PaymentMethodModal from "./Modals/PaymentMethodModal";

export default function InvoicesIndex(props) {
  const [invoices, setInvoices] = useState(props.invoices);
  const [expandedInvoices, setExpandedInvoices] = useState([]);
  const [currentFilter, setCurrentFilter] = useState(null)
  const [openPaymentMethodModal, setOpenPaymentMethodModal] = useState(false);
  const current_user = props.current_user
  const team = props.team
  
  const canCancelAutoPay = (user, invoice) => {
    if (user.user_type == 'donor' && user.id == invoice.user_id && props.team.permit_sub_cancelation) return true 
    if (user.user_type == 'manager' || user.user_type == 'assistant_manager') return true
    return false
  }

  useEffect(() => {
    if (!currentFilter) setCurrentFilter(0)

    if (currentFilter == 0) {
      setInvoices(props.invoices)
    } else if (currentFilter == 1) {
      setInvoices(props.invoices.filter(invoice => !invoice.isRecurring))
    } else {
      setInvoices(props.invoices.filter(invoice => invoice.isRecurring))
    }

    totalForChildInvoices()
  }, [currentFilter])

  const totalForChildInvoices = () => {
    invoices.map(invoice => {
      if (invoice.isRecurring && !invoice.isChild && !invoice.due_date) {
        invoice.child_invoices.map(child_invoice_id => {
          invoices.map(capturedInvoice => {
            if (child_invoice_id == capturedInvoice.id) {
              capturedInvoice.total_invoice_cost = invoice.total_invoice_cost;
            }
          })
        })
      }
    })
  }

  const changeFilter = (num) => {
    setCurrentFilter(num)
  }

  const cancelAutoPay = (invoice) => {
    HTTP.patch(`/subscription/cancel_a_subscription`, {
      invoice: invoice,
    })
    .then((response) => {
        Alert.show("notice", "Autopay disabled successfully!");
        setTimeout(() => window.location.reload(), 1500)
    })
    .catch((e) => {
        Alert.show("error", "Could not open the page. Try again or refresh.");
    });
  }

  const endInvoice = (invoice) => {
    HTTP.patch(`/end_invoice/${invoice.id}`, {
      invoice: invoice,
    })
    .then((response) => {
        Alert.show("notice", "Invoice ended successfully!");
        setTimeout(() => window.location.reload(), 1500)
    })
    .catch((e) => {
        Alert.show("error", "Could not open the page. Try again or refresh.");
    });
  }

  const filteredInvoices = invoices.filter(invoice => !invoice.isChild);
  const childInvoices = invoices.filter(invoice => invoice.isChild);

  const toggleInvoiceExpansion = (invoice) => {
    const childInvoiceList = [];
    if (invoice.child_invoices.length > 0) {
      const children = invoice.child_invoices;
      for (let i = 0; i < children.length; i++) {
        const childInvoice = invoices.find(invoice => invoice.id === children[i]);
        if (!expandedInvoices.includes(childInvoice)) {
          childInvoiceList.push(childInvoice);
        }
      }
      if (expandedInvoices.some(expandedInvoice => invoice.child_invoices.includes(expandedInvoice.id))) {
        // Some child invoices are already expanded, so we need to close them
        setExpandedInvoices(expandedInvoices.filter(expandedInvoice => !invoice.child_invoices.includes(expandedInvoice.id)));
      } else {
        // No child invoices are expanded, so we need to open them
        setExpandedInvoices([...expandedInvoices, ...childInvoiceList]);
      }
    }
  };

  const getInvoiceAmount = (invoice, amount) => {
    let total = amount

    if (invoice.use_stripe && invoice.pass_processing_fee) {
      if (invoice.isRecurring) {
        let raw_amount = parseFloat(amount)
        let fee = (((raw_amount + 0.30) / (1 - 0.034)) - raw_amount).toFixed(2)
        total = (parseFloat(raw_amount) + parseFloat(fee)).toFixed(2)
      }

      if (!invoice.isRecurring) {
        let raw_amount = parseFloat(amount)
        let fee = (((raw_amount + 0.30) / (1 - 0.034)) - raw_amount).toFixed(2)
        total = (parseFloat(raw_amount) + parseFloat(fee)).toFixed(2)
      }
    }

    return total
  }

  const showOverdueInvoice = (invoice) => {
    if (invoice.isRecurring && !invoice.isChild) return false 

    if (invoice.status == "overdue" || invoice.status == "active" || invoice.status == "sent") {
      if (invoice.due_date && new Date(invoice.due_date_timestamp) < new Date() && invoice.use_stripe) {
        return true
      }
    }

    return false
  }

  return (
    <React.Fragment>
      <div className="overflow">
        <div className="nav nav-line nav-sub nav-color-secondary">
          <a className={currentFilter == 0 ? 'nav-link active show' : 'nav-link'} href="#" onClick={() => changeFilter(0)}>
            All Invoices
          </a>
          <a className={currentFilter == 1 ? 'nav-link active show' : 'nav-link'} href="#" onClick={() => changeFilter(1)}>
            One-Time Invoices
          </a>
          <a className={currentFilter == 2 ? 'nav-link active show' : 'nav-link'} href="#" onClick={() => changeFilter(2)}>
            Recurring Invoices
          </a>
        </div>
      </div>

      <div className="card">
        <div>
          <div className="list-group list-group-flush">
            {filteredInvoices.map((invoice) => (
              <div>
                <div className="list-group-item">
                  <div className='list-group-item-body'>
                    <div className='list-group-item-body-main-invoices' >
                      <div>
                        {showOverdueInvoice(invoice) && (
                          <span class="badge badge-fail badge-sm mr-2">Overdue</span>
                        )}
                        {!showOverdueInvoice(invoice) && (
                          <>
                            {invoice.status == "active" && (
                              <span class="badge badge-success badge-sm mr-2">{invoice.status}</span>
                            )}
                            {invoice.status == "sent" && (
                              <span class="badge badge-info badge-sm mr-2">{invoice.status}</span>
                            )}
                            {invoice.status == "draft" && (
                              <span class="badge badge-draft badge-sm mr-2">{invoice.status}</span>
                            )}
                            {invoice.status == "expired" && (
                              <span class="badge badge-primary badge-sm mr-2">{invoice.status}</span>
                            )}
                            {invoice.status == "paid" && (
                              <span class="badge badge-paid badge-sm mr-2">{invoice.status}</span>
                            )}
                          </>
                        )}
                      </div>
                      <div className="list-item-title-segment">
                        <span style={{fontWeight: 'bold'}}>Invoice Number: </span>{invoice.invoice_number}
                      </div>
                      {invoice.isRecurring != true &&
                        <div className="list-item-title-segment d-none-mobile">
                          <span style={{fontWeight: 'bold'}}>Due Date: </span>{invoice.due_date}
                        </div>
                      }
                      <div className="list-item-title-segment d-none-mobile">
                        <span style={{fontWeight: 'bold'}}>Total: </span> ${getInvoiceAmount(invoice, invoice.total_invoice_cost)}
                      </div>

                      {invoice.auto_pay && invoice.system_generated &&
                        <div className="list-item-title-segment d-none-mobile mr-3">
                          <span className="bg-primary btn-sm text-white">Continuous</span>
                        </div>
                      }

                      {invoice.is_endless_invoice && 
                        <div className="list-item-title-segment d-none-mobile mr-3">
                          <span className="bg-primary btn-sm text-white">Continuous</span>
                        </div>
                      }

                      {invoice.offer_auto_pay && invoice.isRecurring &&
                        <div className="list-item-auto-pay d-none-mobile">
                            {!invoice.auto_pay && !invoice.auto_pay_ended &&
                              <span className="custom-auto-pay-bg btn-sm text-white"> Auto pay offered</span>
                            }
                            {!invoice.auto_pay && invoice.auto_pay_ended &&
                              <span className="bg-primary btn-sm text-white"> Auto pay ended</span>
                            }
                            {invoice.auto_pay &&
                              <span className="bg-success btn-sm text-white"> Auto pay active</span>
                            }
                        </div>
                      }
                    </div>
                  </div>
                  <div className='list-group-item-actions d-none-mobile'>
                    {childInvoices.filter(child => invoice.child_invoices.includes(child.id)).length > 0 && (
                      <>
                        {invoice.auto_pay && props.team.allow_donor_to_change_payment_method && current_user.id == invoice.user_id && !invoice.auto_pay_ended &&
                          <button 
                            onClick={() => setOpenPaymentMethodModal(invoice)} 
                            className={`btn btn-sm ${invoice.stripe_payment_failed ? 'btn-danger' : 'btn-success'} d-none-mobile`}
                          >
                            Change Payment Method
                          </button>
                        }
                        <button onClick={() => toggleInvoiceExpansion(invoice)} className="btn btn-sm btn-outline-primary d-none-mobile">View All Recurring Invoices</button>
                      </>
                    )}

                    {invoice.isRecurring != true && invoice.isChild != true &&
                      <a href={`../${invoice.user_id}/invoices/${invoice.id}`} className="btn btn-sm btn-outline-primary d-none-mobile">View Invoice</a>
                    }

                    {(current_user.user_type == 'manager' || current_user.user_type == 'assistant_manager' || current_user.user_type == 'sponsorship_manager') &&
                    <div className="btn-group btn-group-sm">
                      <button onClick={() => {window.location = `../${invoice.user_id}/invoices/${invoice.id}/edit`}}
                        className={`btn btn-sm btn-primary ml-2 d-none-mobile ${invoice.auto_pay && current_user.user_type !== 'sponsorship_manager'? "btn-split-left mr-0" : ""}`}
                      >
                        <i className="fa fa-pencil"></i>
                        Edit Invoice Settings
                      </button>

                      {canCancelAutoPay(current_user, invoice) && (invoice.auto_pay || invoice.is_endless_invoice) &&
                        <>
                          <button type="button" className="btn btn-primary btn-narrow dropdown-toggle dropdown-toggle-split btn-split-right" data-toggle="dropdown" aria-expanded="false">
                            <span className="sr-only">Toggle Dropdown</span>
                          </button>
                          <ul className="dropdown-menu dropdown-menu-right">
                            {invoice.is_endless_invoice &&
                              <li>
                                <button onClick={() => endInvoice(invoice)}
                                  name="button"
                                  className="dropdown-item text-primary"
                                  type="button">
                                    End Invoice
                                </button>
                              </li>
                            }   

                            {invoice.auto_pay && !invoice.auto_pay_ended &&
                              <li>
                                <button onClick={() => cancelAutoPay(invoice)}
                                  name="button"
                                  className="dropdown-item text-danger"
                                  type="button">
                                    Cancel Auto Pay
                                </button>
                              </li>
                            }    
                          </ul>
                        </>
                      }
                    </div>
                    }
                  </div>

                  <div class= "dropdown">
                    <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Actions
                    </button>
                    <ul class="dropdown-menu">
                    {childInvoices.filter(child => invoice.child_invoices.includes(child.id)).length > 0 && (
                      <>
                        {invoice.auto_pay && team.allow_donor_to_change_payment_method && current_user.id == invoice.user_id && !invoice.auto_pay_ended &&
                          <li 
                            class={`dropdown-item dropdown-header ${invoice.stripe_payment_failed ? 'text-danger' : 'text-success'}`}
                            onClick={() => setOpenPaymentMethodModal(invoice)}
                          >
                            Change Payment Method
                          </li>
                        }
                        <li class="dropdown-item" onClick={() => toggleInvoiceExpansion(invoice)}>
                            View All Recurring Invoices
                        </li>
                      </>
                    )}
                    {invoice.isRecurring != true && invoice.isChild != true &&
                        <li class="dropdown-item" onClick={() => window.location = `../${invoice.user_id}/invoices/${invoice.id}`}>
                          View Invoice
                        </li>
                    }
                    {(current_user.user_type == 'manager' || current_user.user_type == 'assistant_manager' || current_user.user_type == 'sponsorship_manager') &&
                      !invoice.stripe_id &&
                        <li class="dropdown-item" onClick={() => window.location = `../${invoice.user_id}/invoices/${invoice.id}/edit`}>
                          Edit Invoice Settings
                        </li>
                    }
                    {canCancelAutoPay(current_user, invoice) && invoice.auto_pay == true && !invoice.auto_pay_ended &&
                        <li class="dropdown-item text-danger" onClick={() => cancelAutoPay(invoice)}>
                          Cancel Auto Pay
                        </li>
                    }
                    </ul>
                  </div>

                </div>
                {expandedInvoices.length > 0 && (
                  <div>
                    {expandedInvoices.filter(child => invoice.child_invoices.includes(child.id)).length > 0 && (
                      <div>
                        {expandedInvoices.filter(child => invoice.child_invoices.includes(child.id)).map((child) => (
                          <div className="list-group-item">
                            <div className='list-group-item-body'>
                              <div className='list-group-item-body-main-invoices' >
                              <div>
                                {showOverdueInvoice(child) && (
                                  <span class="badge badge-fail badge-sm mr-2">Overdue</span>
                                )}
                                {!showOverdueInvoice(child) && (
                                  <>
                                    {child.status == "active" && (
                                      <span class="badge badge-success badge-sm mr-2">{child.status}</span>
                                    )}
                                    {child.status == "sent" && (
                                      <span class="badge badge-info badge-sm mr-2">{child.status}</span>
                                    )}
                                    {child.status == "draft" && (
                                      <span class="badge badge-draft badge-sm mr-2">{child.status}</span>
                                    )}
                                    {child.status == "expired" && (
                                      <span class="badge badge-primary badge-sm mr-2">{child.status}</span>
                                    )}
                                    {child.status == "paid" && (
                                      <span class="badge badge-paid badge-sm mr-2">{child.status}</span>
                                    )}
                                  </>
                                )}
                              </div>
                                <div className="list-item-title-segment">
                                  <span style={{fontWeight: 'bold'}}>Invoice Number: </span>{child.invoice_number}
                                </div>
                                <div className="list-item-title-segment d-none-mobile">
                                  <span style={{fontWeight: 'bold'}}>Due Date: </span>{child.due_date}
                                </div>
                                <div className="list-item-total d-none-mobile">
                                  <span style={{fontWeight: 'bold'}}>Total: </span> ${getInvoiceAmount(invoice, invoice.total_invoice_cost)}
                                </div>
                              </div>
                            </div>
                            <div className='list-group-item-actions'>
                              <a href={`../${child.user_id}/invoices/${child.id}`} className="btn btn-sm btn-outline-primary">View Invoice</a>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        {invoices.length == 0 &&
          <div className="card-body">
            Let's get started and create your first invoice :)
          </div>
        }

        {openPaymentMethodModal &&
          <PaymentMethodModal
            invoice={openPaymentMethodModal}
            close={() => setOpenPaymentMethodModal(false)}
          />  
        }
      </div>
    </React.Fragment>
  );
}

InvoicesIndex.propTypes = {
  invoices: PropTypes.array
};
